module.exports = __webpack_public_path__ + "static/FY_2021_Investor_Presentation-6e5947cf618f0f59550a576ef8bbfbfb.pdf";